// LocalStorage functions for the Investigation tool.

import { Platform } from "react-native";

const isWeb = Platform.OS === "web" && typeof window !== "undefined";

export const storageGet = (key: string): string | null => {
  try {
    if (isWeb) return localStorage.getItem(key);
  } catch (err) {
          console.error(`storageGet failed for key="${key}":`, err)
        }
  return null;
};

export const storageSet = (key: string, value: string): void => {
  try {
    if (isWeb) localStorage.setItem(key, value);
  } catch (err) {
      console.error(`storageSet failed for key="${key}":`, err)
    }
};

export const storageKeyFor = (
  bizIdOrName: string,
  scopeKey: string,
  step: number,
  qid: string
) => `investigation:${bizIdOrName}:${scopeKey}:${step}:${qid}`;

export const storageGetJSON = <T,>(key: string): T | undefined => {
  try {
    if (isWeb) {
      const raw = localStorage.getItem(key);
      if (raw === null) return undefined;
      return JSON.parse(raw) as T;
    }
  } catch (err) {
          console.error(`storageGetJSON failed for key="${key}":`, err)
        }
  return undefined;
};

export const storageSetJSON = (key: string, value: unknown): void => {
  try {
    if (isWeb) localStorage.setItem(key, JSON.stringify(value));
  } catch (err) {
          console.error(`storageSetJSON failed for key="${key}":`, err)
        }
};

export const storageRemoveKey = (key: string): void => {
  try {
    if (isWeb) localStorage.removeItem(key);
  } catch (err) {
          console.error(`storageRemoveKey failed for key="${key}":`, err)
        }
};

//Hydrate answers from localStorage
export function hydrateStepAnswersFor(
  bizIdOrName: string,
  scopeKey: string,
  stepIndex: number,
  stepCfg: { questions: Array<{ id: string }> }
): Record<string, boolean | string> {
  const out: Record<string, boolean | string> = {};
  for (const q of stepCfg.questions) {
    const k = storageKeyFor(bizIdOrName, scopeKey, stepIndex, q.id);
    const v = storageGetJSON<boolean | string>(k);
    if (typeof v !== "undefined") out[q.id] = v;
  }
  return out;
}

// Collect all answers from localStorage
export function collectAllAnswersSnapshot(
  bizIdOrName: string,
  scopeKey: string,
  steps: Array<{ questions: Array<{ id: string }> }>
): Record<number, Record<string, boolean | string>> {
  const out: Record<number, Record<string, boolean | string>> = {};
  steps.forEach((stepCfg, idx) => {
    const perStep = hydrateStepAnswersFor(bizIdOrName, scopeKey, idx, stepCfg);
    if (Object.keys(perStep).length) out[idx] = perStep;
  });
  return out;
}
